export default class ColorTools {
  static getColorsPalette() {
    return [
      ['244,67,54', '233,30,99', '156,39,176', '103,58,183', '63,81,181', '33,150,243', '3,169,244', '0,188,212', '0,150,136', '76,175,80', '139,195,74', '205,220,57', '255,235,59', '255,193,7', '255,152,0', '255,87,34', '121,85,72', '158,158,158', '96,125,139', '255,255,255'],
      ['255,235,238', '252,228,236', '243,229,245', '237,231,246', '232,234,246', '227,242,253', '225,245,254', '224,247,250', '224,242,241', '232,245,233', '241,248,233', '249,251,231', '255,253,231', '255,248,225', '255,243,224', '251,233,231', '239,235,233', '250,250,250', '236,239,241', '229,229,229'],
      ['255,205,210', '248,187,208', '225,190,231', '209,196,233', '197,202,233', '187,222,251', '179,229,252', '178,235,242', '178,223,219', '200,230,201', '220,237,200', '240,244,195', '255,249,196', '255,236,179', '255,224,178', '255,204,188', '215,204,200', '245,245,245', '207,216,220', '204,204,204'],
      ['239,154,154', '244,143,177', '206,147,216', '179,157,219', '159,168,218', '144,202,249', '129,212,250', '128,222,234', '128,203,196', '165,214,167', '197,225,165', '230,238,156', '255,245,157', '255,224,130', '255,204,128', '255,171,145', '188,170,164', '238,238,238', '176,190,197', '178,178,178'],
      ['229,115,115', '240,98,146', '186,104,200', '149,117,205', '121,134,203', '100,181,246', '79,195,247', '77,208,225', '77,182,172', '129,199,132', '174,213,129', '220,231,117', '255,241,118', '255,213,79', '255,183,77', '255,138,101', '161,136,127', '224,224,224', '144,164,174', '153,153,153'],
      ['239,83,80', '236,64,122', '171,71,188', '126,87,194', '92,107,192', '66,165,245', '41,182,246', '38,198,218', '38,166,154', '102,187,106', '156,204,101', '212,225,87', '255,238,88', '255,202,40', '255,167,38', '255,112,67', '141,110,99', '189,189,189', '120,144,156', '127,127,127'],
      ['244,67,54', '233,30,99', '156,39,176', '103,58,183', '63,81,181', '33,150,243', '3,169,244', '0,188,212', '0,150,136', '76,175,80', '139,195,74', '205,220,57', '255,235,59', '255,193,7', '255,152,0', '255,87,34', '121,85,72', '158,158,158', '96,125,139', '102,102,102'],
      ['229,57,53', '216,27,96', '142,36,170', '94,53,177', '57,73,171', '30,136,229', '3,155,229', '0,172,193', '0,137,123', '67,160,71', '124,179,66', '192,202,51', '253,216,53', '255,179,0', '251,140,0', '244,81,30', '109,76,65', '117,117,117', '84,110,122', '76,76,76'],
      ['211,47,47', '194,24,91', '123,31,162', '81,45,168', '48,63,159', '25,118,210', '2,136,209', '0,151,167', '0,121,107', '56,142,60', '104,159,56', '175,180,43', '251,192,45', '255,160,0', '245,124,0', '230,74,25', '93,64,55', '97,97,97', '69,90,100', '50,50,50'],
      ['198,40,40', '173,20,87', '106,27,154', '69,39,160', '40,53,147', '21,101,192', '2,119,189', '0,131,143', '0,105,92', '46,125,50', '85,139,47', '158,157,36', '249,168,37', '255,143,0', '239,108,0', '216,67,21', '78,52,46', '66,66,66', '55,71,79', '25,25,25'],
      ['183,28,28', '136,14,79', '74,20,140', '49,27,146', '26,35,126', '13,71,161', '1,87,155', '0,96,100', '0,77,64', '27,94,32', '51,105,30', '130,119,23', '245,127,23', '255,111,0', '230,81,0', '191,54,12', '62,39,35', '33,33,33', '38,50,56', '0,0,0']
    ]
  }

  static _find(c500, realColors) {
    let find = false
    let colorsPalette = this.getColorsPalette()
    let i = 1
    let j = 0
    for (i = 1; i < colorsPalette.length; i++) {
      for (j = 0; j < colorsPalette[i].length; j++) {
        if (colorsPalette[i][j] == c500) {
          find = true
          break
        }
      }

      if (find) {
        break
      }
    }

    let colors = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900]
    let result = {}
    if (find) {
      for (let ind in colors) {
        let newi
        if (realColors) {
          newi = +ind + 1
        } else {
          newi = Math.min(colorsPalette.length - 1, Math.max(1, i - (5 - ind)))
        }
        result['c' + colors[ind]] = colorsPalette[newi][j]

      }
    } else {
      // генерим оттенки сами (:
      let tinycolor = require('tinycolor2')
      let x = tinycolor(`rgb(${c500})`)
      let colorBase = x.clone()

      result['c500'] = c500
      for (let i = 6; i < 10; i++) {
        let rgb = colorBase.darken(7).toRgb()
        result['c' + colors[i]] = `${rgb.r},${rgb.g},${rgb.b}`
      }
      colorBase = x.clone()
      for (let i = 4; i >= 0; i--) {
        let rgb = colorBase.lighten(10).toRgb()
        result['c' + colors[i]] = `${rgb.r},${rgb.g},${rgb.b}`
      }
    }
    return result
  }


  static getAllShadesColorSettings(color) {
    let colors = this._find(color)

    let template = {
      c50: [ '--md-pallete-50', '--md-pallete-on-50', '--md-pallete-rgb-50', '--md-pallete-rgb-on-50' ],
      c100: [ '--md-pallete-100', '--md-pallete-on-100', '--md-pallete-rgb-100', '--md-pallete-rgb-on-100' ],
      c200: [ '--md-pallete-200', '--md-pallete-on-200', '--md-pallete-rgb-200', '--md-pallete-rgb-on-200' ],
      c300: [ '--md-pallete-300', '--md-pallete-on-300', '--md-pallete-rgb-300', '--md-pallete-rgb-on-300' ],
      c400: [ '--md-pallete-400', '--md-pallete-on-400', '--md-pallete-rgb-400', '--md-pallete-rgb-on-400' ],
      c500: [ '--md-pallete-500', '--md-pallete-on-500', '--md-pallete-rgb-500', '--md-pallete-rgb-on-500' ],
      c600: [ '--md-pallete-600', '--md-pallete-on-600', '--md-pallete-rgb-600', '--md-pallete-rgb-on-600' ],
      c700: [ '--md-pallete-700', '--md-pallete-on-700', '--md-pallete-rgb-700', '--md-pallete-rgb-on-700' ],
      c800: [ '--md-pallete-800', '--md-pallete-on-800', '--md-pallete-rgb-800', '--md-pallete-rgb-on-800' ]
    }

    let result = {}
    for (let tmp in template) {
      if (!Object.prototype.hasOwnProperty.call(template, tmp) || !colors[tmp]) {
        continue
      }
      let textColor = this.colorOnBackground(colors[tmp])
      result[template[tmp][0]] = `rgb(${colors[tmp]})`
      result[template[tmp][1]] = `rgb(${textColor})`
      result[template[tmp][2]] = colors[tmp]
      result[template[tmp][3]] = textColor
    }
    return result
  }


  static colorOnBackground(rgbBackgroundColor) {
    let values = rgbBackgroundColor.split(',')
    let r = values[0]
    let g = values[1]
    let b = values[2]
    //YIQ формула для вычисления контрастного цвета в формате RGB
    let yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000
    return yiq >= 128 ? '0,0,0' : '255,255,255'
  }
}
